import * as React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import HelperText from '../HelperText';

export interface TextAreaProps
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  error?: boolean;
  helperText?: string;
  label: string;
  showLabel?: boolean;
  onChange?: (value: string) => void;
}

const TextArea: React.FC<TextAreaProps> = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      onChange,
      label,
      className,
      required = true,
      error,
      helperText,
      showLabel = false,
      placeholder,
      ...restProps
    },
    ref
  ) => {
    const { t } = useTranslation();
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (onChange) {
        onChange(e.target.value);
      }
    };
    return (
      <div className="flex flex-col flex-1 basis-50">
        {showLabel && (
          <label
            className="text-neutral-900 dark:text-neutral-50 font-semibold mb-2"
            htmlFor={label}
          >{`${t(label)} ${required ? '*' : ''}`}</label>
        )}
        <textarea
          id={label}
          ref={ref}
          {...restProps}
          onChange={handleChange}
          rows={5}
          className={clsx(
            'flex w-full disabled:cursor-not-allowed text-neutral-900  disabled:opacity-50 placeholder:text-neutral-500 dark:text-neutral-50 dark:placeholder:text-neutral-400 rounded-[24px] px-6 py-3 outline-none bg-neutral-50 dark:bg-neutral-700',
            error && 'ring-2 ring-error-main ring-offset-1',
            className
          )}
          placeholder={placeholder || `${t(label)}`}
        />
        {error && helperText && <HelperText error helperText={helperText} className="mt-2" />}
      </div>
    );
  }
);

export default TextArea;
